<template>
<form @submit.prevent="update">
  <div class="project-update row gutter-md">
    <div class="col-12">
      <div class="row gutter-md justify-center">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
            <field :errors="errors" :required="true" model="project" name="name" v-model="item.name" placeholder="Tech con 2016"></field>
            <field :errors="errors" model="project" name="location" v-model="item.location" placeholder="Berlin"></field>
            <div class="row gutter-sm">
              <div class="col-xs-12 col-sm-12 col-md-6">
                <div class="field" :class="{'is-unvalid': start_date_error}">
                  <label for="start_date">{{$t('models.project.start_date')}}</label>
                  <datepicker
                    :clear-button="true"
                    :disabled-dates="{ from: new Date(formattedEndDate) }"
                    input-class="input--datepicker"
                    id="start_date"
                    name="start_date"
                    v-model="formattedStartDate"
                    :language="getDatePickerLanguage()"
                  />
                  <p class="validation-message" v-if="start_date_error">{{$t('errors.' + start_date_error)}}</p>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                <div class="field" :class="{'is-unvalid': end_date_error}">
                  <label for="end_date">{{$t('models.project.end_date')}}</label>
                  <datepicker
                    :clear-button="true"
                    :disabled-dates="{ to: new Date(formattedStartDate) }"
                    input-class="input--datepicker"
                    id="end_date"
                    name="end_date"
                    v-model="formattedEndDate"
                    :language="getDatePickerLanguage()"
                  />
                  <p class="validation-message" v-if="end_date_error">{{$t('errors.' + end_date_error)}}</p>
                </div>
              </div>
            </div>
            <div class="classification-container">
              <field
                type="radio"
                :collection="classificationCollection"
                v-model="item.default_classification"
                @input="inputClassification"
                :label="$t('models.project.default_classification')"
                :params="{'no_i18n': true}"
                model="project"
                class="is-buttonned"
                :class="selectClass"
                name="default_classification"
              />
            </div>
            <form-switch id="scope_leads" v-model="item.scope_leads_to_user" label="models.project.scope_leads" :value="item.scope_leads_to_user"/>
            <div v-if="!currentPlanIsTalents" >
              <form-switch v-if="showCrmSyncSwitch()" :errors="errors" v-model="item.sync_disabled" :reverse="true" model="project" name="sync_disabled" :value="item.sync_disabled"/>
              <form-switch :errors="errors" v-model="item.background_xml_export_enabled" model="project" name="background_xml_export_enabled" :value="item.background_xml_export_enabled"/>
              <form-switch v-if="allowedLeadReview()" :errors="errors" v-model="item.enable_lead_review" model="project" name="enable_lead_review" :value="item.enable_lead_review"/>
            </div>
            <q-collapsible v-if="!currentPlanIsTalents" class="additional_data" :label="$t('models.project.set_aditional_data_content')">
              <div>
                <field :errors="errors" model="project" v-can="'organizations.list'" name="organization_id" :params="{ no_i18n: true}" type="select" :collection="organizations" v-model="item.organization_id"></field>
                <field :errors="errors" model="project" name="crm_campaign_id"  class="field" v-model="item.additional_data.crm_campaign_foreign_id"></field>
                <field :errors="errors" model="project" name="crm_sales_employee_id"  class="field" v-model="item.additional_data.crm_sales_employee_foreign_id"></field>
                <field :errors="errors" model="project" name="crm_marketing_employee_id"  class="field" v-model="item.additional_data.crm_marketing_employee_foreign_id"></field>
                <field :errors="errors" model="project" name="crm_group_code_id"  class="field" v-model="item.additional_data.crm_group_code_foreign_id"></field>
                <div class="field" :class="{'is-unvalid': baseScoreError()}">
                  <field model="project" name="base_score"  class="field" v-model.number="item.additional_data.base_score"></field>
                  <p class="validation-message" v-if="baseScoreError()">{{$t('errors.base_score_error')}}</p>
                </div>
                  <div class="field">
                    <field :errors="errors" model="project" name="mailchimp_list_id"  class="field" v-model="item.additional_data.mailchimp_list_id"></field>
                  </div>
              </div>
            </q-collapsible>

        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
          <div class="row">
            <div class="col-lg-12">
              <p class="form-subtitle ">{{ $t('ui.project_wizard.lead-sheets') }}</i></p>
            </div>
            <form class="project-update--form right col-xs-12 col-sm-12" @submit.prevent>
              <div class="row gutter-sm">
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="leadsheet-box" ref='basic' @click="setLeadSheet('basic')">
                      <img src="../../../assets/leadsheet-standard.svg">
                      <p>Standard</p>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="leadsheet-box" ref='advanced' @click="setLeadSheet('advanced')">
                      <img src="../../../assets/leadsheet-advanced.svg">
                      <p>Advanced</p>
                    </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="lead-sheet-selector" ref='none' >
                      <field v-if="this.leadMasks.length > 0" :errors="errors" model="project" @input="setLeadSheet('none')" v-can="'lead_masks.list'" name="lead_mask_id" :params="{ no_i18n: true}" type="select" :collection="leadMasks" v-model="item.lead_mask_id"></field>
                        <router-link :to="{ name:'lead_masks'}">{{$t('ui.project.create_leadsheet')}}</router-link>
                    </div>
                  </div>
              </div>
              <div class="info-box" v-if="isCurrentlySelectedBasicOrAdvanced">
                <img src="../../../assets/info-message.svg">
                <div class="info info-standard" v-if="currentlySelected == 'basic'">
                  <p class="bold-text">{{$t('ui.project.standard_title')}}</p>
                  <br>
                  <p class="bold-text">{{$t('ui.project.standard_subtitle_1')}}</p>
                  <p>{{$t('ui.project.standard_description_1')}}</p>
                  <br>
                  <p class="bold-text">{{$t('ui.project.standard_subtitle_2')}}</p>
                  <p>{{$t('ui.project.standard_description_2')}}</p>
                </div>
                <div class="info info-advanced" v-if="currentlySelected == 'advanced'">
                  <p class="bold-text">{{$t('ui.project.advanced_title')}}</p>
                  <br>
                  <p class="bold-text">{{$t('ui.project.advanced_subtitle_1')}}</p>
                  <p>{{$t('ui.project.advanced_description_1')}}</p>
                  <br>
                  <p class="bold-text">{{$t('ui.project.advanced_subtitle_2')}}</p>
                  <p>{{$t('ui.project.advanced_description_2')}}</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  <div class="col-xs-12 col-sm-12 col-12">
      <div class="actions">
        <button class="btn btn-tertiary btn-flat" @click.prevent="cancel" data-action="project.cancel">{{ $t('ui.global.cancel') }}</button>
        <button v-if="type" class="btn btn-primary btn-flat btn-save" type="submit" data-action="project.update">{{ $t('ui.pages.project-' + type + '-button') }}</button>
      </div>
    </div>
  </div>
</form>
</template>
<script>
import Api from '@/api/Project.js'
import OrganizationApi from '@/api/Organization.js'
import UserApi from '@/api/User.js'
import BusinessKitApi from '@/api/BusinessKit.js'
import moment from 'moment'
import FormSwitch from '@/components/helpers/DataInput/FormSwitch'
import LeadMaskApi from '@/api/LeadMask'
import {updateMixin} from '@/components/mixins/Update'
import Datepicker from "vuejs-datepicker"
import project_categories from '@/config/data/project_categories'
import Permission from '@/classes/Permission'
import Ui from '@/classes/Ui'

let user_structure = [
  { name: 'id', credentials: "is_root"},
  { name: 'firstname' },
  { name: 'lastname' },
  { name: 'email', sortable: true },
  { name: 'action', type: 'unassign', exclude: ['show'] }
]

let businesskit_structure = [
  { name: 'id', credentials: 'root' },
  { name: 'name', sortable: true },
  { name: 'action', type: 'unassign', exclude: ['show'] }
]

export default {
  mixins: [updateMixin],
  components: {
    Datepicker,
    Ui,
    FormSwitch
  },
  data(){
    return {
      projectNavigation: [
        { name: "project_leads", action: "project_leads.list", redential: "project_leads.list"},
        { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" },
        { name: "project_edit", action: "project.edit", credential: "projects.update" },
        { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }
      ],
      model: "projects",
      api: new Api(),
      organizations: [],
      name: "project",
      project_categories,
      start_date_error: "",
      end_date_error: "",
      leadMasks: [],
      user_structure,
      businesskit_structure,
      additional_data_displayed: false,
      project_data_displayed: false,
      additional_data: {},
      selectClass: '',
      currentlySelected: null,
      item: {
        additional_data: {}
      }
    }
  },
  mounted() {
    this.init()
    Ui.setSecondaryHeaderTabs(this.projectNavigation)
    this.clearSelected()
    this.retrieve_associations()
    this.item = { additional_data: {} }
  },
  beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', [])
  },
  computed: {
    isCurrentlySelectedBasicOrAdvanced: {
      get () {
        return ['basic', 'advanced'].includes(this.currentlySelected)
      }
    },
    classificationCollection() {
      return [
        {
          name: this.$t('models.select_classification.hot'),
          value: 'hot',
          color: 'red'
        },
        {
          name: this.$t('models.select_classification.warm'),
          value: 'warm',
          color: 'orange'
        },
        {
          name: this.$t('models.select_classification.cold'),
          value: 'cold',
          color: 'blue'
        }
      ]
    },
    formattedStartDate: {
      get () {
        if (this.item.start_date) {
        let startDate = moment(this.item.start_date).format('YYYY-MM-DD');
        return startDate
        }
      },
      set (val) {
        this.item.start_date = val
      }
    },
    formattedEndDate: {
      get () {
        if (this.item.end_date) {
          let endDate = moment(this.item.end_date).format('YYYY-MM-DD');
          return endDate
        }
      },
      set (val) {
        this.item.end_date = val
      }
    },
    title(){
      if(this.type == "update"){
        return "ui.pages.project-edit";
      }else{
        return "ui.pages.project-create";
      }
    },
    currentPlanIsTalents() {
      // Don't show lead sheet selection if current plan is talents
      return this.$store.getters.getCurrentPlanIsTalent
    }
  },
  methods: {
    inputClassification(value){
      if (!!value) {
      if (!value) {
        value = 'unclassified'
      }
      this.selectClass = 'value--' + value
      this.$emit('input','classification',value)
     }
    },
    setLeadSheet(leadSheet){
      this.clearSelected()
      let reference = this.$refs[leadSheet]
      if (reference) {
        if ('classes' in reference) {
          reference = reference.$el
        }
        reference.classList.add('selected')
        if (leadSheet == 'none') {
          delete this.item.lead_sheet
          this.currentlySelected = leadSheet
        } else {
          this.item.lead_sheet = leadSheet
          this.currentlySelected = leadSheet
        }
      }
    },
    clearSelected() {
      Array.from(document.getElementsByClassName('selected')).forEach((el) => {
        el.classList.remove('selected')
      })
    },
    validate() {
      this.$store.commit('RESET_PROJECT_WIZARD_ERRORS')
      if (this.item.lead_sheet === undefined && this.item.lead_mask_id === undefined) {
        this.$store.commit('ADD_PROJECT_WIZARD_ERROR', {
          field_name: 'lead_mask_id',
          code: `project.lead_mask_id.invalid`
        })
      }
      return this.errors.length == 0
    },
    retrieve(id) {
      this.api[this.retrieve_method](id).then((item) => {
        this.item = item
        Ui.setPageLevel("3")
        Ui.setSubtitle({link: {name: "projects"}})
        Ui.setTitle({ label: this.title, params: { name: item.name } })
        Ui.setPageType(this.singular_model)
        Ui.clearHeaderButtons()
        Ui.finishLoading()
        this.handleLeadSheet()
      })
    },
    handleLeadSheet() {
      if(this.item.lead_mask && this.item.lead_mask.default) {
        let type = this.item.lead_mask.default_type
        this.setLeadSheet(type)
      }
    },
    update(){
      this.dropNonNumericBaseScore()
      this.api.post(this.item).then((item) => {
        this.item = item
        this.$store.commit('SET_CURRENT_PROJECT', item)
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + this.singular_model + '.message.' + this.type,
          'type': 'success'
        })
        this.$router.push({name: "project_leads", params: { id: item.id }})
      }).catch((e) => {
        console.error(e)
        this.errors = e.response.data.errors
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'errors.' + e.response.data.errors[0].code,
          'type': 'error'
        })
      })
    },
    retrieve_associations(){
      let permission = Permission.loadPermissions()

      if(Permission.can(permission, 'organizations.list')){
        let api = new OrganizationApi()
        api.all_for_association().then((items) => {
          this.organizations = items
        }).catch(function(error) {
          console.error(error)
        })
      }

      if(Permission.can(permission, 'lead_masks.list')){
        let api = new LeadMaskApi()
        api.all_for_association().then((items) => {
          this.leadMasks = items
        }).catch(function(error) {
          console.error(error)
        })
      }

    },
    additionalDataInitializer() {
      if (typeof this.item.additional_data == 'undefined') { this.item.additional_data = {} }
    },
    baseScoreError() {
      if ((this.item.additional_data.base_score == undefined) || (typeof this.item.additional_data.base_score === 'number') || ( this.item.additional_data.base_score == '')) {
        return false
      } else {
        return true
      }
    },
    dropNonNumericBaseScore() {
      if (!(typeof this.item.additional_data.base_score === 'number')) {
        return this.item.additional_data.base_score = undefined
      }
    },
    allowedLeadReview() {
      return this.$store.getters.getCurrentUserIsRoot
    },
    showCrmSyncSwitch () {
      return this.$store.getters.getOrganizationConfig('crm_presence') || this.$store.getters.getOrganizationConfig('enable_crm_sync_switches')
    }
  },
  watch: {
    errors (errors){
      this.error = undefined
      this.errors.forEach((error) => {
        if(error.field_name == "start_date"){
          this.start_date_error = this.$t(error.code)
        }
        if(error.field_name == "end_date"){
          this.end_date_error = this.$t(error.code)
        }
      })
    },
  }
}

</script>
<style lang="scss">
.project-update--form .form-switch label {
  white-space: pre-wrap !important;
}

.project-update {
  .input--datepicker {
    height: 38px;
    padding: 0 10px;
  }
  .classification-container {
    margin-top: 20px;
    .field.is-buttonned > label {
      margin-bottom: 5px;
      font-size: 16px;
    }
    .field--radio,
    .field--wrapper {
      margin-bottom: 0px !important;
    }
  }
  #scope_leads {
    margin-top: 25px;
  }
  .form-switch {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    label {
      margin-left: 10px;
    }
  }

  .switch-container {
    margin-top: 0;
  }
  .additional_data {
      background-color: $paper-light;
      border-radius: 5px;
      margin-top: 30px;
      .q-item {
        height: 55px;
        border-bottom: 0;
        &:after {
          content: '\E930';
          position: absolute;
          right: 14px;
          top: 0px;
          font-size: 1.4em;
          line-height: 3.6rem;
          font-family: 'yule-icon-set';
          color: $ink;
        }
      }
      .q-item-label {
        color: $ink-dark;
        font-weight: 500;
        font-size: 16px;
      }
      .q-collapsible-sub-item {
        background: #fff;
        border: 2px solid $paper-light;
        border-top: 0;
        padding-top: 20px;
      }
      i {
        display: none;
      }
  }
}
</style>
<style lang="scss" scoped>

.info-box {
  background-color: #EBF4FA;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 20px;
  margin-bottom: 20px;
  img {
    margin-right: 10px;
  }
  .info {
    p {
    color: $ink-light;
    margin-bottom: 0;
    &.bold-text {
      color: $ink;
      font-weight: 500;
      margin-bottom: 4px;
      &:first-of-type {
        margin-bottom: 0;
      }
    }
   }
  }
}
.actions{
  text-align: right;
  margin-top: 20px;
}

.justify-center {
  justify-content: center;
}

.value--hot {

  select{
    background-color: $lead-hot;
    color: $red-dark;
    }
  }
  .value--warm {
    select {
      background-color: $lead-warm;
      color: #9C6F19;
    }
  }
  .value--cold {
    select {
      background-color: $lead-cold;
      color: #00828E;
  }
 }
  .value--unclassified{
    select{
      background-color: $lead-unclassified;
    }
 }
.classification {
  select {
    border-radius: 4px;
    padding-left: 1em;
  }
  .field--select {
    border: 2px solid transparent;
  }
  .input--select-wrapper {
    width: 217px;
    &:after{
      color: $ink-dark;
      height: 3rem;
      font-size: 1em;
      padding-right: .5em;
    }
  }
  .field--wrapper{
    .input--select{
      margin-left: 0;
      margin-bottom: 0;
      width: 206px;
      height: 3rem;
      line-height: 38px;
    }
  }
}

.field .optional{
  display: none;
}
.lead-sheet-selector {
  background: #F3F5F6;
  padding: 30px;
  margin-bottom: 20px;
  margin-top: 1em;
  width: 100%;
  border: 2px solid transparent;
  a {
    font-weight: 500;
  }
}
.selected{
   border: 2px solid #007AFF;
   transition: .3s all ease-in;
   border-radius: 4px;
}

.vdp-datepicker  {
  width: 100%;
}

.padding {
  padding-bottom: 3em;
}

.project_data--title, .additional_data--title {
  cursor: pointer;
  font-size: 16px;
  width: 400px;
  color: #333;
}

.form-subtitle {
  color: #6A7A8A;
  margin-bottom: 1em;
}

.leadsheet-box {
  height: 176px;
  background-color: #F3F5F6;
  text-align: center;
  border: 2px solid #F3F5F6;
  border-radius: 4px;
  transition: all .15s ease-out;
  cursor: pointer;
  @media(max-width: 1057px) {
    margin-bottom: .5em;
  }
  img {
    margin-top: 1.5em;
  }
  &.selected{
     border: 2px solid #007AFF;
  }
}
.grid-2 {
  justify-content: flex-start;
    @media(max-width: 1057px) {
      flex-direction: column;
    }

}
.input--datepicker {
  padding-left: 1.5em;
  height: 38px;
}


h4 {
  margin-bottom: 1.2em;
  font-weight: 400;
  font-size: 1.8em;
}

h3 {
  margin-bottom: 1.2em !important;
  font-weight: 400;
  font-size: 2em;
}


.project-update .btn-tertiary {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// ProjectUpdate.vue?bbc6d51a